import request from '@/tool/request'

const c = 'TaskSpongemanLogin/';

// 登录
export function login(query) {
  return request({
    url: c+'login',
    method: 'post',
    data:query
  })
}
// 注册
export function reg(query) {
  return request({
    url: c+'reg',
    method: 'post',
    data:query
  })
}
// 忘记密码
export function forgot(query) {
  return request({
    url: c+'forgot',
    method: 'post',
    data:query
  })
}

// 获取短信验证码
export function getCode(query) {
  return request({
    url: c+'getCode',
    method: 'post',
    data:query
  })
}

// 获取图片验证码
export function imgCaptcha(query) {
  return request({
    url: c+'imgCaptcha',
    method: 'post',
    data:query
  })
}